import React from 'react'
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {MinusCircleFilled, PlusCircleFilled} from '@ant-design/icons'

import './index.less'
import './mobile.less'

import noImage from '@/assets/img/icon/noImage.png'
import favoriteDefaultIcon from '@/assets/img/icon/favoriteDefault.png'
import favoriteActiveIcon from '@/assets/img/icon/favoriteActive.png'
import {LANGUAGE_CHINESE_KEY} from '@/constants';
import {getFormatMoney} from '@/common';
import {PRODUCT_ITEM_BTN_TYPE_1, PRODUCT_ITEM_BTN_TYPE_2, PRODUCT_ITEM_BTN_TYPE_3} from '@/constants';

const defaultProps = {
  img: noImage,
  name: '',
  description: '',
  onCategoryItemClick: () => {},
  productType: null,
  quantity: 0,
}
export default function CategoryItem(props) {
  const options = Object.assign({}, defaultProps, props);

  const {t} = useTranslation()
  
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'product-item-mobile-container' : 'product-item-container'
  const {locale} = commonState
  
  const handleCategoryItemClick = () => {
    options.onCategoryItemClick()
  }
    
  return (
    <div className={rootClassName} onClick={handleCategoryItemClick}>
      <div className={'product-item-img-container'}>
        {options.img ? <img src={options.img} alt=""/> : <img src={noImage} alt=""/>}
      </div>
      <div className={'product-item-name overflow-ellipsis-2'}>
        <span>{options.name}</span>
      </div>
      <div className={'product-item-des overflow-ellipsis-2'}>
        <span>{options.description}</span>
      </div>
    </div>
  )
}
